<div
  class="chat-message"
  [class.chat-message-w-full]="contentIsComponent()"
  [class.chat-message-sender]="message.isUserMessage"
>
  <div class="message-avatar" *ngIf="!message?.isUserMessage && (message.showAvatar ?? true)">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#B0D3D9" />
      <svg
        x="8"
        y="8"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.67409 4.65983L10.3642 6.57115C11.1307 8.69246 12.8057 10.3629 14.9327 11.1275L16.8491 11.8157C17.0218 11.8783 17.0218 12.1226 16.8491 12.1843L14.9327 12.8725C12.8057 13.637 11.1307 15.3075 10.3642 17.4288L9.67409 19.3402C9.61135 19.5124 9.36643 19.5124 9.30455 19.3402L8.61447 17.4288C7.8479 15.3075 6.17296 13.637 4.04598 12.8725L2.12955 12.1843C1.95682 12.1217 1.95682 11.8774 2.12955 11.8157L4.04598 11.1275C6.17296 10.3629 7.8479 8.69246 8.61447 6.57115L9.30455 4.65983C9.36643 4.48669 9.61135 4.48669 9.67409 4.65983Z"
          fill="white"
        />
        <path
          d="M18.3008 0.0662106L18.6505 1.03387C19.039 2.10781 19.8872 2.95376 20.964 3.34117L21.9343 3.69001C22.0219 3.72172 22.0219 3.84514 21.9343 3.87686L20.964 4.22569C19.8872 4.6131 19.039 5.45905 18.6505 6.53299L18.3008 7.50066C18.269 7.58808 18.1452 7.58808 18.1134 7.50066L17.7637 6.53299C17.3752 5.45905 16.527 4.6131 15.4502 4.22569L14.48 3.87686C14.3923 3.84514 14.3923 3.72172 14.48 3.69001L15.4502 3.34117C16.527 2.95376 17.3752 2.10781 17.7637 1.03387L18.1134 0.0662106C18.1452 -0.0220702 18.2698 -0.0220702 18.3008 0.0662106Z"
          fill="white"
        />
        <path
          d="M18.3008 16.5L18.6505 17.4676C19.039 18.5416 19.8872 19.3875 20.964 19.775L21.9343 20.1238C22.0219 20.1555 22.0219 20.2789 21.9343 20.3106L20.964 20.6595C19.8872 21.0469 19.039 21.8928 18.6505 22.9668L18.3008 23.9344C18.269 24.0219 18.1452 24.0219 18.1134 23.9344L17.7637 22.9668C17.3752 21.8928 16.527 21.0469 15.4502 20.6595L14.48 20.3106C14.3923 20.2789 14.3923 20.1555 14.48 20.1238L15.4502 19.775C16.527 19.3875 17.3752 18.5416 17.7637 17.4676L18.1134 16.5C18.1452 16.4126 18.2698 16.4126 18.3008 16.5Z"
          fill="white"
        />
      </svg>
    </svg>
  </div>
  <div
    class="message-content"
    [class.message-content-spacer]="!contentIsComponent()"
    [ngClass]="message.isUserMessage ? 'message-content-sender' : 'message-content-receiver'"
  >
    <div
      *ngIf="!isLoading && !contentIsComponent()"
      class="message-text"
      [innerHtml]="formattedContent"
    ></div>

    <ng-container>
      <div *ngIf="message.content && contentIsComponent()" class="d-none"></div>
      <ng-container #dynamicComponentHost></ng-container>
    </ng-container>
    <div *ngIf="isLoading">
      <div class="loading-dots-container">
        <div class="dot" style="--wave-delay: 0s; --shimmer-delay: 0.1s"></div>
        <div class="dot" style="--wave-delay: 0.2s; --shimmer-delay: 0.3s"></div>
        <div class="dot" style="--wave-delay: 0.4s; --shimmer-delay: 0.5s"></div>
      </div>
    </div>
    <div class="message-footer" *ngIf="!contentIsComponent()">
      <span class="message-timestamp">{{ message.timestamp | date: 'shortTime' }}</span>
    </div>
  </div>
  <div class="message-avatar" *ngIf="message.isUserMessage && (message.showAvatar ?? true)">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#243345" />
      <text
        x="50%"
        y="50%"
        dominant-baseline="middle"
        text-anchor="middle"
        fill="white"
        font-size="16"
      >
        {{ 'habaChat.iconName' | cxTranslate }}
      </text>
    </svg>
  </div>
</div>
